import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import rolePlay from "../../../assets/images/roleplay.png";
import xCircle from "../../../assets/images/XCircle.png";

const RoleplaySwapModal = ({ visible, onDecline }) => {
  return (
    <Dialog.Root open={visible} onOpenChange={onDecline}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />
        <Dialog.Content
          className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
          bg-white rounded-2xl p-4 w-[80vw] max-w-md flex flex-col items-center"
        >
          <div
            className="bg-[#E9BE50] border-4 border-white rounded-full h-20 w-20 
            flex items-center justify-center -mt-10 shadow-md"
          >
            <img
              src={rolePlay}
              alt="Roleplay"
              className="h-10 w-10 object-contain"
            />
          </div>

          <Dialog.Close asChild>
            <button
              className="absolute right-2 top-2 p-1"
              onClick={onDecline}
            >
              <img
                src={xCircle}
                alt="Close"
                className="h-5 w-5 object-contain"
              />
            </button>
          </Dialog.Close>

          <Dialog.Title
            className="text-black font-medium text-sm text-center px-6 pb-2 mt-4"
            style={{ fontFamily: 'Lato, sans-serif' }}
          >
            Role Players have been swapped!
          </Dialog.Title>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default RoleplaySwapModal;